import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';

import {
  CommonMediaQueries,
  IconModule,
  MediaScreenService,
} from '@hglobal/fin-ui';

import { DotPulseComponent } from '@iw/common';
import { ProfileService } from '@iw/core/services';
import { environment } from '@iw/environment';

import { SHELL_API, ShellApiService, ShellMockApiService } from './api';
import { HeaderComponent } from './header';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { ShellStore } from './shell.store';

@Component({
  selector: 'iw-shell',
  styleUrl: './shell.component.scss',
  templateUrl: './shell.component.html',
  imports: [
    RouterOutlet,
    HeaderComponent,
    IconModule,
    MobileNavComponent,
    DotPulseComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: SHELL_API,
      useClass: environment.useMocks ? ShellMockApiService : ShellApiService,
    },
  ],
})
export class ShellComponent {
  readonly #mediaScreenService = inject(MediaScreenService);
  readonly #shellStore = inject(ShellStore);
  readonly #profileService = inject(ProfileService);
  readonly #router = inject(Router);

  readonly isDesktop = toSignal(
    this.#mediaScreenService.mediaMatcher(CommonMediaQueries.MD),
  );

  readonly me = this.#profileService.me;

  deviceSizeEffect = effect(() => {
    const url = this.#router.url;

    if (!this.isDesktop() && url.startsWith('/dashboard')) {
      this.#router.navigate(['/mobile/home']);
    }
    if (this.isDesktop() && url.startsWith('/mobile')) {
      this.#router.navigate(['/dashboard']);
    }
  });
}
